var _g, _rect, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _path6, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 109,
    viewBox: "0 0 98 109",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_998_47305)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.4492,
    y: 90,
    width: 62.0001,
    height: 6,
    fill: "#1B3554"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.9492,
    y: 8,
    width: 62.0001,
    height: 39.5,
    fill: "#E0E5EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9492 8V68H2.94922V31.7183L7.95001 24.0432L12.9492 8Z",
    fill: "#CFD4DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4492 8V68H84.4492V31.7183L79.4484 24.0432L74.4492 8Z",
    fill: "#CFD4DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94922 31.5H84.4493V99.5C84.4493 100.881 83.33 102 81.9493 102H5.44922C4.06851 102 2.94922 100.881 2.94922 99.5V31.5Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4492 59.2739C27.4492 58.924 27.6289 58.5986 27.9398 58.438C28.6316 58.0807 29.9535 57.5 31.2381 57.5C32.5222 57.5 33.8064 58.0802 34.4755 58.4376C34.777 58.5986 34.9492 58.9176 34.9492 59.2594C34.9492 60.0645 34.0221 60.5923 33.2646 60.3196C32.6561 60.1005 31.9406 59.9231 31.2192 59.9231C30.4836 59.9231 29.7479 60.1076 29.1244 60.3326C28.3683 60.6055 27.4492 60.0777 27.4492 59.2739Z",
    fill: "#1B3554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9492 59.2739C52.9492 58.924 53.1289 58.5986 53.4398 58.438C54.1316 58.0807 55.4535 57.5 56.7381 57.5C58.0222 57.5 59.3064 58.0802 59.9755 58.4376C60.277 58.5986 60.4492 58.9176 60.4492 59.2594C60.4492 60.0645 59.5221 60.5923 58.7646 60.3196C58.1561 60.1005 57.4406 59.9231 56.7192 59.9231C55.9836 59.9231 55.2479 60.1076 54.6244 60.3326C53.8683 60.6055 52.9492 60.0777 52.9492 59.2739Z",
    fill: "#1B3554"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 43.9492,
    cy: 69.5015,
    rx: 8.00001,
    ry: 3.50152,
    fill: "#1B3554"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.149343,
    cx: 25.4492,
    cy: 39,
    rx: 3,
    ry: 3,
    fill: "#1B3554"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.149343,
    cx: 61.9492,
    cy: 39,
    rx: 3,
    ry: 3,
    fill: "#1B3554"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4492 38.8463V20.25C25.4492 10.1708 33.62 2 43.6992 2C53.7784 2 61.9493 10.1708 61.9493 20.25V38.8463",
    stroke: "#5E7085",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_998_47305)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.2492,
    cy: 88.3,
    rx: 8.80001,
    ry: 8.8,
    fill: "#00FFE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_998_47305",
    x: 0.355741,
    y: 77.9065,
    width: 86.187,
    height: 30.187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.04674,
    result: "effect1_foregroundBlur_998_47305"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_998_47305",
    x: 71.4492,
    y: 76.5,
    width: 25.6016,
    height: 25.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.415686 0 0 0 0 0.596078 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_998_47305"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_998_47305",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.bcf02c41ac733b63aa89f07286a473cc.svg";
export { ForwardRef as ReactComponent };